module.exports = __webpack_public_path__ + "img/Broken Pendant.cc6b0c18.png";